import { render } from "./IndexChatMessage.vue?vue&type=template&id=284a365f"
import script from "./IndexChatMessage.vue?vue&type=script&lang=js"
export * from "./IndexChatMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__